/**
 * Paleta de cores para o dashboard
 */

export const CORES = {
  // Métricas principais
  pessoas: '#8884d8',      // Roxo
  refeicoes: '#82ca9d',    // Verde
  km: '#ffc658',           // Amarelo
  voluntarios: '#ff7300',  // Laranja
  horas: '#00C49F',        // Verde-azulado
  rondas: '#6366f1',       // Indigo
  
  // Estados
  positivo: '#10b981',     // Verde
  negativo: '#ef4444',     // Vermelho
  neutro: '#6b7280',       // Cinza
  
  // Entidades (gerar dinamicamente para mais de 6)
  entidades: [
    '#8884d8', '#82ca9d', '#ffc658', 
    '#ff7300', '#00C49F', '#FFBB28',
    '#FF8042', '#0088FE', '#00C49F'
  ],
  
  // Heatmap
  heatmapMin: '#f0f9ff',   // Azul muito claro
  heatmapMax: '#1e40af',   // Azul escuro
  
  // Backgrounds
  cardBg: '#ffffff',
  pageBg: '#f3f4f6',
  
  // Texto
  textPrimary: '#111827',
  textSecondary: '#6b7280',
  textMuted: '#9ca3af'
};

export const getCorEntidade = (index) => {
  return CORES.entidades[index % CORES.entidades.length];
};

export const getCorVariacao = (valor) => {
  if (valor > 0) return CORES.positivo;
  if (valor < 0) return CORES.negativo;
  return CORES.neutro;
};

export const getCorHeatmap = (valor, max) => {
  if (!max || max === 0) return CORES.heatmapMin;
  const intensidade = Math.min(valor / max, 1);
  // Interpolar entre heatmapMin e heatmapMax
  // Simplificado: usar opacidade
  return `rgba(30, 64, 175, ${intensidade})`;
};
